const timeGridOneDayStep = 1
const timeGridFiveDayStep = 7
const timeGridSevenDayStep = 7

export const rangeLength = (currentView) => {
  switch (currentView) {
    case 'timeGridOneDay':
      return timeGridOneDayStep
    case 'timeGridFiveDay':
      return timeGridFiveDayStep
    case 'timeGridSevenDay':
    default:
      return timeGridSevenDayStep
  }
}
